export default "__VITE_PUBLIC_ASSET__4c03abc6__"